angular.module('edxComponents')
  .component('edxCreateNweaAssignmentForm', {
    templateUrl: '/resources/components/assign-focus/create-nwea-assignment/create-nwea-assignment-form.component.html',
    controller: [
      'edxNweaAssignmentService',
      'assignMode',
      '$scope',
      '$state',
      'dblAnalyticsProvider',
      'edxPendingChangesModalService',
      '$q',
      CreateNweaAssignmentFormController
    ],
    controllerAs: 'vm',
    bindings: {
      mode: '@edxMode',
      id: '<edxId'
    }
  });

function CreateNweaAssignmentFormController(
  nweaAssignmentService,
  assignModeService,
  $scope,
  $state,
  dblAnalyticsProvider,
  edxPendingChangesModalService,
  $q
) {
  var vm = this;

  //
  // Public Exports
  //
  vm.$onChanges = $onChanges;
  vm.$onInit = $onInit;
  vm.onDomainSelect = onDomainSelect;
  vm.onGradeBandSelect = onGradeBandSelect;
  vm.onScoreRangeSelect = onScoreRangeSelect;
  vm.studentHasAssignments = studentHasAssignments;
  vm.studentHasScoreSelectionError = studentHasScoreSelectionError;
  vm.studentHasErrors = studentHasErrors;
  vm.assignmentAllowedForStudent = assignmentAllowedForStudent;
  vm.sort = sort;

  vm.loading = true; // true if data is being loaded
  vm.students = []; // list of students
  vm.assignments = {}; // map from student's userId to array of active assignments

  function $onInit() {
    $scope.$on('createAssignmentTriggered', _onCreateAssignment);
    _enableDisableAddAssignmentButton();

  }

  this.$onDestroy = function () {
    nweaAssignmentService.clearCaches();
  };

  function $onChanges(changes) {
    if (changes.id) {
      _refreshStudents();
    }
  }

  /**
   * Determines if a student has at least 1 active assignment.
   *
   * @param student
   * @return {boolean}
   */
  function studentHasAssignments(student) {
    return _.isArray(vm.assignments[student.id]) && vm.assignments[student.id].length > 0;
  }

  /**
   * Determines if student has at least 1 error
   */
  function studentHasErrors(student) {
    return _.isObject(student.error) && _.keys(student.error).length > 0;
  }

  /**
   * Determines if student has score range specific errors
   */
  function studentHasScoreSelectionError(student) {
    return student.error &&
      (student.error.DUPLICATE_ASSIGNMENT || student.error.NOT_PLAYABLE_IN_PRIMARY || student.error.INVALID_SCORE_RANGE_SELECTION);
  }

  /**
   * Determines if new assignments are allowed for this student
   *
   * @param student
   * @return {boolean}
   */
  function assignmentAllowedForStudent(student) {
    return !_.isArray(vm.assignments[student.id]) || vm.assignments[student.id].length < 2;
  }

  /**
   * Callback for when the grade selection changes.
   *
   * @param student The student object for which the selection is made
   * @param level The grade band object which was selected
   */
  function onGradeBandSelect(student, level) {
    // Note that the domain drop down is bound to student.level.id and "sees" this update

    // Only set info as dirty after the init setting
    if(student.level) {
      edxPendingChangesModalService.setIsPending(true);
    }

    student.level = level;
  }

  /**
   * Callback for when the domain selection changes.
   *
   * @param student The student object for which the selection is made
   * @param domain The domain object which was selected
   */
  function onDomainSelect(student, domain) {
    // Note that the score range drop down is bound to student.domain.id and "sees" this update

    // Only set info as dirty after the init setting, which inits to undefined
    if(domain) {
      edxPendingChangesModalService.setIsPending(true);
    }

    student.domain = domain;
  }

  /**
   * Callback for when the score range selection changes.
   *
   * @param student The student object for which the selection is made
   * @param scoreRange The scoreRange object which was selected
   */
  function onScoreRangeSelect(student, scoreRange) {
    edxPendingChangesModalService.setIsPending(true);
    _clearError(student, 'INVALID_SCORE_RANGE_SELECTION');

    // We only validate on score range selection because a domain must be selected in order to make a score selection
    _validateAssignment(student, scoreRange).then(function(){
      if (_.isEmpty(student.error)) {
        student.scoreRange = scoreRange;
      } else {
        student.scoreRange = undefined;
      }
      _enableDisableAddAssignmentButton();
    });
  }

  vm.enableSort = false;

  /**
   * Determine if sort is ascending or descending
   *
   * true = ascending
   * false = descending
   */
  vm.sortAscending = true;

  /**
   * The attribute on which to sort
   */
  vm.sortAttribute = 'lastName';

  /**
   * Set the attribute to sort by or flip sort order
   *
   * If the attribute is already the sort attribute then flip the sort order
   *
   * @param attribute
   */
  function sort(attribute) {
    if (attribute === vm.sortAttribute) {
      vm.sortAscending = !vm.sortAscending;
    } else {
      vm.sortAttribute = attribute;
      vm.sortAscending = true;
    }
  }

  /**
   * Refresh our list of students and their active assignments
   * @private
   */
  function _refreshStudents() {
    if (_.isNumber(vm.id) || _.isString(vm.id)) {
      vm.loading = true;

      // Load the students
      _loadStudents(vm.mode, vm.id).then(function(students) {
        vm.students = students;
        // This form is used for both student and classroom view, so distinguish between the two by the number of
        // students. Sorting should only be enabled in the classroom view.
        vm.enableSort = students.length > 1;

        // Load active assignments for the students
        return nweaAssignmentService.loadAssignments(_extractStudentIdsAsArray(students));
      }).then(function(assignments){

        // Grab the student's active engagement from the unfiltered assignment list
        // Student's with no real active assignments get a fake assignment which has the engagement
        // The fake assignments gets filter out of our assignment list, but we need it to get engagement
        var unfilteredByUserId = _.groupBy(assignments, function (assignment) { return assignment.userId; });
        _.forEach(vm.students, function (student){
          if (unfilteredByUserId[student.id]) {
            student.activeEngagement = unfilteredByUserId[student.id][0].activeEngagement;
          }
        });

        // Filter out fake assignments and group by userId
        vm.assignments = _.chain(assignments)
          .filter(function(assignment) { return assignment.id > 0; })
          .groupBy(function(assignment) { return assignment.userId; })
          .value();
      }).catch(function(){
        vm.students = [];
        vm.assignments = {};
      }).finally(function(){
        vm.loading = false;
      });
    }
  }

  /**
   * Load students based on mode and id
   *
   * @param mode
   * @param id
   * @return Promise
   * @private
   */
  function _loadStudents(mode, id) {
    if (mode === 'classroom') {
      return nweaAssignmentService.loadStudentsForClassroom(id);
    } else {
      return nweaAssignmentService.loadStudent(id).then(function(student){
        return [student];
      });
    }
  }

  /**
   * Map array of student objects to array of student user IDs
   *
   * @param students
   * @return {Array}
   * @private
   */
  function _extractStudentIdsAsArray(students) {
    return _.map(students, function(student){
      return student.id;
    });
  }

  /**
   * Determines if a student already has an assignment for the given score range.
   *
   * Note that this is determined based on the assignments loaded during component initialization.  This does not
   * issue a new query.
   *
   * @param student
   * @param scoreRange
   * @return {*}
   * @private
   */
  function _studentHasAssignment(student, scoreRange) {
    if (student && scoreRange) {
      var studentAssignments = vm.assignments[student.id];
      return studentAssignments && !!_.find(studentAssignments, function (assignment) {
        return assignment.focusType === 'CLUSTER' && assignment.focusId === Number(scoreRange.id);
      });
    } else {
      return false;
    }
  }

  /**
   * Asynchronously validate that the proposed assignment is valid.
   *
   * This will add a property to the student object named 'error'.  The error property is an object with a key defined
   * for each validation error.
   *
   * Invoking validation with undefined domain or scoreRange will clear all of the errors.
   *
   * @param student Student object to receive the assignment
   * @param domain Domain object of proposed assignment
   * @param scoreRange ScoreRange object of proposed assignment
   * @return Promise which is resolved when all validations complete
   * @private
   */
  function _validateAssignment(student, scoreRange) {
    return $q.all([
      _duplicateAssignmentValidation(student, scoreRange)
    ]);
  }

  /**
   * Asynchronously performs a duplicate assignment validation.
   *
   * This validation fails if the student is already assigned the given domain and scoreRange.
   *
   * @param student Student object to receive the assignment
   * @param domain Domain object of proposed assignment
   * @param scoreRange ScoreRange object of proposed assignment
   * @return Promise which is resolved when the validation completes
   * @private
   */
  function _duplicateAssignmentValidation(student, scoreRange) {
    if (_studentHasAssignment(student, scoreRange)) {
      _setError(student, 'DUPLICATE_ASSIGNMENT');
    } else {
      _clearError(student, 'DUPLICATE_ASSIGNMENT');
    }
    return $q.resolve();
  }

  /**
   * Used by _validateAssignment to set a validation error
   *
   * @param student Student object with the error
   * @param error The error string to set
   * @private
   */
  function _setError(student, error) {
    if (!student.error) {
      student.error = {};
    }
    student.error[error] = error;
  }

  /**
   * Used by _validateAssignment to clear a validation error
   *
   * @param student Student object with the error
   * @param error The error string to clear
   * @private
   */
  function _clearError(student, error) {
    if (student.error) {
      delete student.error[error];
    }
  }

  /**
   * Callback for when the user clicks the create assignment button.
   *
   * This is invoked by subscribing to the 'createAssignmentTriggered' event broadcast by the create assignment "dialog".
   *
   * @private
   */
  function _onCreateAssignment() {
    // Check for students having a domain selected, but no scoreRange
    var invalidStudents = _.filter(vm.students, function(student){
      return !!student.domain && !student.scoreRange;
    });
    if (invalidStudents.length > 0) {

      dblAnalyticsProvider.eventTrack('Invalid NWEA Score Range', {
        category: 'Assign Focus',
        label: vm.mode,
        value: invalidStudents.length.toString()  // Values are stored as a string in Edex Analytics. GA will parse to an int.
      });

      _.forEach(invalidStudents, function(student){
        _setError(student, 'INVALID_SCORE_RANGE_SELECTION');
      });
    } else {
      _createAssignments();
    }

  }

  function _createAssignments() {
    edxPendingChangesModalService.setIsPending(false);
    var pending = _.chain(vm.students)
      .filter(function(student){return !!student.domain && !!student.scoreRange;})
      .map(function(student){
        return {
          focusType: "CLUSTER",
          classroomId: $state.params.classroomId,
          userId: student.id,
          domainId: student.domain.id,
          scoreRangeId: student.scoreRange.id
        };
      })
      .value();
    if (pending.length > 0) {
      assignModeService.disableAddAssignment();
      nweaAssignmentService.createAssignments(pending).then(function () {
        dblAnalyticsProvider.eventTrack('NWEA Assignment Created', {
          category: 'Assign Focus',
          label: vm.mode,
          value: pending.length.toString()  // Values are stored as a string in Edex Analytics. GA will parse to an int.
        });


        vm.students = [];
        vm.assignments = {};
        // Toggle out of assignment mode
        assignModeService.onClickAssignMode();
      }).catch(function (rejection) {
        _enableDisableAddAssignmentButton();
        assignModeService.onCreateAssignmentRejected(rejection);
      });
    }
  }

  /**
   * Enables or disables the add assignment button based on the current selections.
   *
   * This should be invoked whenever a change is made that may affect the state of the add assignment button.
   *
   * @private
   */
  function _enableDisableAddAssignmentButton() {
    // Enable the add assignment button if any student has a domain and score range selected
    // Note that if the select score range results in a validation error then the score range will not be set on the
    // student object.  Therefore, any students with a validation error will not be counted here.
    var enable = _.reduce(
      _.map(vm.students, function(student){
        return !!student.domain && !!student.scoreRange;
      }), function(acc, n){
        return acc || n;
      });
    if (enable) {
      assignModeService.enableAddAssignment();
    } else {
      assignModeService.disableAddAssignment();
    }
  }
}
